import React, { useState } from 'react';
import { Button, Modal, Image} from 'react-bootstrap';
import SalirIcon from '../../../../Images/salir.svg';
import ReponerTarjeta from '../../../../Images/reposicion-tarjeta.svg';
import CancelarTarjeta from '../../../../Images/cancelar-tarjeta.svg'
import GoArrow from '../../../../Images/go_arrow.svg';
import './modalSettings.css';

export const ModalSettings = (props) => {
  const [asignModal,setAsignModal] = useState("modal_settings")
  const [replaceModal, setReplaceModal] = useState(false);
  const [cancelCard, setCancelCard] = useState(false);


  const HiddenModal = () => {
    setReplaceModal(false);
    props.onHide()
  }
  const HiddenCancelCard = () => {
    setCancelCard(false)
    props.onHide()
  }

  return (
    <>
    {
      !replaceModal && !cancelCard &&
      <Modal
        id="modal_settings"
        className="modal_settings"
        size="lg"
        show={props.show}
        aria-labelledby="example-modal-sizes-title-sm"
      >
          <Modal.Header style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
              <Image src={SalirIcon} onClick={() => props.onHide()} alt="X" style={{cursor: 'pointer'}}/>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <Modal.Title className="title-settings">{props.traductions.Card.enabled.modalSettings.title}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body style={{padding: '10px 60px 50px'}}>
            <div 
              style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer'}}
              onClick={() => setReplaceModal(true)}
            >
              <div>
                <Image src={ReponerTarjeta} className='background-grey'/>
                <span>{props.traductions.Card.enabled.modalSettings.L_reposition}</span>
              </div>
              <div>
                <Image src={GoArrow}/>
              </div>
            </div>

            <div 
              style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '28px', cursor: 'pointer'}}
              onClick={() => setCancelCard(true) }
            >
              <div>
                <Image src={CancelarTarjeta} className='background-grey'/>
                <span>{props.traductions.Card.enabled.modalSettings.L_cancel}</span>
              </div>
              <div>
                <Image src={GoArrow}/>
              </div>
              
            </div>
          </Modal.Body>
        
        </Modal>
      }
     
      <Modal
        id="modal_reposition"
        size="lg"
        show={replaceModal}
        aria-labelledby="example-modal-sizes-title-sm"
      >
          <Modal.Header  style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
              <Image src={SalirIcon} onClick={HiddenModal} alt="X" style={{cursor: 'pointer'}}/>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <Modal.Title className="title-settings">{props.traductions.Card.enabled.modalCardReplacement.title}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body style={{padding: '10px 60px 50px'}}>
            <div style={{textAlign: 'center'}}>
              <span className='text-call-number'>{props.traductions.Card.enabled.modalCardReplacement.L_body}</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '30px'}}>
              <span className='phone-number-blue'>+52 81 9034 9039</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '30px'}}>
              <Button onClick={HiddenModal} className='ghost-cancelar'>{props.traductions.Card.enabled.modalCardReplacement.L_cancel}</Button>
            </div>
          </Modal.Body>
      </Modal>

      <Modal
        id="modal_cancelation"
        size="lg"
        show={cancelCard}
        aria-labelledby="example-modal-sizes-title-sm"
      >
          <Modal.Header style={{display: 'flex', flexDirection: 'column'}} className='custom-header-settings'>
            <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
              <Image src={SalirIcon} onClick={HiddenCancelCard} alt="X" style={{cursor: 'pointer'}}/>
            </div>
            <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <Modal.Title className="title-settings">{props.traductions.Card.enabled.modalCardCancelation.title}</Modal.Title>
            </div>
          </Modal.Header>
          <Modal.Body style={{padding: '10px 60px 50px'}}>
          <div style={{textAlign: 'center'}}>
              <span className='text-call-number'>{props.traductions.Card.enabled.modalCardCancelation.L_body}</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '30px'}}>
              <span className='phone-number-blue'>+52 81 9034 9039</span>
            </div>
            <div style={{textAlign: 'center', marginTop: '30px'}}>
              <Button onClick={HiddenCancelCard} className='ghost-cancelar'>{props.traductions.Card.enabled.modalCardCancelation.L_cancel}</Button>
            </div>
          </Modal.Body>
      </Modal>
    </>
    
  )
}